export default __webpack_public_path__ + "static/media/iso.739fd2d8.png";